import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum FrequencyHHDisciplineEnum {
    Nursing = "Nursing",
    PT = "PT",
    OT = "OT",
    ST = "ST",
    HHA = "HHA",
    MSW = "MSW"
}

class FrequencyHHDisciplineClass extends EnumWithDescription<FrequencyHHDisciplineEnum> {
    public readonly enum = FrequencyHHDisciplineEnum;
    public readonly enumName: string = "FrequencyHHDisciplineEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<FrequencyHHDisciplineEnum>> = new Map([
        [
            "Nursing",
            {
                name: "Nursing",
                value: FrequencyHHDisciplineEnum.Nursing
            }
        ],
        [
            "OT",
            {
                name: "OT",
                value: FrequencyHHDisciplineEnum.OT
            }
        ],
        [
            "PT",
            {
                name: "PT",
                value: FrequencyHHDisciplineEnum.PT
            }
        ],
        [
            "ST",
            {
                name: "ST",
                value: FrequencyHHDisciplineEnum.ST
            }
        ],
        [
            "HHA",
            {
                name: "HHA",
                value: FrequencyHHDisciplineEnum.HHA
            }
        ],
        [
            "MSW",
            {
                name: "MSW",
                value: FrequencyHHDisciplineEnum.MSW
            }
        ]
    ]);
}

export const FrequencyHHDiscipline = new FrequencyHHDisciplineClass();
